var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "multi-sub-ext" }, [
    _c("label", [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.selectedOpt,
            expression: "selectedOpt"
          }
        ],
        attrs: { type: "radio", value: "1" },
        domProps: { checked: _vm._q(_vm.selectedOpt, "1") },
        on: {
          change: function($event) {
            _vm.selectedOpt = "1"
          }
        }
      }),
      _c("i"),
      _vm._v(" "),
      _c("strong", [_vm._v(_vm._s(_vm.formatPrice(_vm.item, "renewPrice")))]),
      _vm._v(" for 30 days\n  ")
    ]),
    _vm._v(" "),
    _c("label", [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.selectedOpt,
            expression: "selectedOpt"
          }
        ],
        attrs: { type: "radio", value: "2" },
        domProps: { checked: _vm._q(_vm.selectedOpt, "2") },
        on: {
          change: function($event) {
            _vm.selectedOpt = "2"
          }
        }
      }),
      _c("i"),
      _vm._v(" "),
      _c("strong", [_vm._v(_vm._s(_vm.formatPrice(_vm.item, "renewPrice2")))]),
      _vm._v(" for 90 days\n  ")
    ]),
    _vm._v(" "),
    _c("label", [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.selectedOpt,
            expression: "selectedOpt"
          }
        ],
        attrs: { type: "radio", value: "3" },
        domProps: { checked: _vm._q(_vm.selectedOpt, "3") },
        on: {
          change: function($event) {
            _vm.selectedOpt = "3"
          }
        }
      }),
      _c("i"),
      _vm._v(" "),
      _c("strong", [_vm._v(_vm._s(_vm.formatPrice(_vm.item, "renewPrice3")))]),
      _vm._v(" for 1 year\n  ")
    ]),
    _vm._v(" "),
    _c(
      "a",
      {
        staticClass: "subscbtn",
        attrs: { href: "" },
        on: {
          click: function($event) {
            $event.preventDefault()
            _vm.selectedOpt && _vm.$emit("select", _vm.selectedOpt)
          }
        }
      },
      [_vm._v("Extend")]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }